module.exports = __webpack_public_path__ + "edb96e63cc3d6b2a3883135c9765f47a.fbx";